import { useState } from 'react'
import type { ProfileBranch } from '../../lib/types'
import { useStaffText } from '../../ui/StaffText'
import { Pager, usePaged } from '../../ui/Pager'
import { Find } from '../settingsKit'

/** The branches on this profile; a save of the profile is live at each of them. */
export function BranchesStrip({ branches }: { branches: ProfileBranch[] }) {
  const { lang, say } = useStaffText()
  const [find, setFind] = useState('')
  const q = find.trim().toLowerCase()
  const sorted = [...branches]
    .sort((a, b) => a.code.localeCompare(b.code, lang, { numeric: true }))
    .filter((b) => !q || b.name.toLowerCase().includes(q) || b.code.toLowerCase().includes(q))
  const paged = usePaged(sorted, q)

  return (
    <section className="pf-strip" aria-label={say('profiles.branches')}>
      <header className="pf-strip__head">
        <h2 className="pf-strip__title">
          {say('profiles.branches')}
          <span className="pf-strip__count">{branches.length}</span>
        </h2>
        {branches.length > 10 && (
          <Find className="pf-strip__find" value={find} onChange={setFind} label={say('org.br.find')} />
        )}
      </header>

      {sorted.length === 0 ? (
        <p className="pf-muted">{q ? say('org.br.noMatch', { q: find.trim() }) : say('profiles.noBranches')}</p>
      ) : (
        <div className="pf-strip__frame">
          <ul className="pf-strip__rows">
            {paged.rows.map((b) => (
              <li key={b.id} className="pf-strip__row">
                <span className="pf-strip__code">{b.code}</span>
                <span className="pf-strip__name">{b.name}</span>
              </li>
            ))}
          </ul>
          <Pager {...paged.pager} />
        </div>
      )}
    </section>
  )
}
